module.exports = __webpack_public_path__ + "static/media/20_000002.47b16d60.jpg";